import React from 'react'

import { Button, Form, Header } from 'semantic-ui-react'

const MyProfileTeamTab = ({
  teamName,
  organisationWebsite,
  organisationDescription,
  isMobile,
  handleChange,
  handleSubmit,
}: IProps) => (
  <>
    <Header as="h3">Team Details</Header>

    <p style={{ color: '#6b7280' }}>
      Set the default organization profile for this workspace. These details can be shown on contributor-facing project
      pages and reused across projects.
    </p>

    <Form>
      <Form.Field>
        <label>Public team name</label>
        <Form.Input
          type="text"
          placeholder="Example: Green Planet"
          name="teamName"
          value={teamName || ''}
          maxLength={75}
          onChange={handleChange}
        />
        <p style={{ color: '#6b7280', fontSize: '0.9rem', marginTop: '-0.5rem' }}>
          This is the public name shown on upload pages, video galleries and project links. It is separate from the
          legal entity or contest organizer name.
        </p>
      </Form.Field>

      <Form.Field>
        <label>Organization website</label>
        <div style={{ display: 'flex', gap: '1rem', alignItems: 'center' }}>
          <div style={{ flex: 1 }}>
            <Form.Input
              type="text"
              placeholder="https://www.example.com"
              name="organisationWebsite"
              value={organisationWebsite || ''}
              onChange={handleChange}
            />
          </div>

          {organisationWebsite && (
            <a
              href={organisationWebsite.startsWith('http') ? organisationWebsite : `https://${organisationWebsite}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                whiteSpace: 'nowrap',
                alignSelf: 'center',
                marginBottom: '1em',
              }}
            >
              Test link
            </a>
          )}
        </div>
      </Form.Field>

      <Form.Field>
        <Form.TextArea
          label="Organization description"
          name="organisationDescription"
          placeholder="Northstar Energy helps businesses manage renewable power projects across America, combining field expertise data reporting and long-term customer support."
          value={organisationDescription || ''}
          onChange={handleChange}
        />
      </Form.Field>

      <Button primary fluid={isMobile} onClick={handleSubmit}>
        Update
      </Button>
    </Form>
  </>
)

interface IProps {
  teamName: string
  organisationWebsite?: string
  organisationDescription?: string
  isMobile: boolean
  handleChange: (event: any, data: any) => void
  handleSubmit: () => void
}

export default MyProfileTeamTab
